<script setup>
import BaseModal from "@/components/global/modals/BaseModal.vue";
import axios from "axios";
import {ref} from "vue";

const props = defineProps({
  websiteId: {
    type: String,
    required: true
  },
  showModal: {
    type: Boolean,
    default: false,
  }
});

const showModal = ref(props.showModal);

const dismissPermanently = async (updateNow) => {
  const {status} = await axios.post('ajax/ga3-sunset', { websiteId: props.websiteId });
  if (status === 204 && updateNow) {
    window.location.href = `/website/settings/${props.websiteId}`;
  }
  showModal.value = false
};
</script>

<template>
  <BaseModal
    v-if="showModal"
    hide-close-button
  >
    <template #heading>
      Important: Connect Your GA4 Profile
    </template>
    Starting July 1st, Google is fully transitioning to Google Analytics 4 (GA4), and the previous version (GA3) will
    cease to track new data. To continue gaining valuable insights from your website traffic, we strongly recommend
    disconnecting your GA3 profile and connecting your GA4 profile as soon as possible.
    <template #footer>
      <div class="d-flex justify-content-end w-100 mt-3">
        <div
          class="btn btn-success"
          @click="dismissPermanently(true)"
        >
          Update now
        </div>
        <div
          class="btn btn-danger"
          @click="dismissPermanently(false)"
        >
          Dismiss
        </div>
      </div>
    </template>
  </BaseModal>
</template>
